import TimelineHeader from "components/Headers/SimpleHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
import { getPlanWiseUsers } from "action/plans";
import { cancellationSubListing } from "action/plans";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import CustomPagination from "components/CommonComponents/Pagination";
import { cyanBlue } from "pages/TenantDetails/constants/Constants";
import { LIGHT_GRAY } from "components/CommonComponents/Constant";
import { GRAY } from "components/CommonComponents/Constant";
import { Tab, Tabs } from "@mui/material";
import {
  cancelledSubscriptions,
  upcomingCancelSubscriptions,
} from "constants/ReportsConstants/Constants";
import { CURRENCY_SYMBOL } from "components/constants";

function CancelledSubscription() {
  const dispatch = useDispatch();
  const planList = useSelector((state) => state.planReducer.plansTenantList);
  const data = useSelector(
    (state) => state.CancellationSubListReducer.cancellationSubList
  );
  const [value, setValue] = useState(cancelledSubscriptions);
  const today = new Date().toISOString().split("T")[0];
  const [searchData, setSearchData] = useState({
    name: "",
    email: "",
    planName: "",
    startDate: value === upcomingCancelSubscriptions ? today : "",
    endDate: value === cancelledSubscriptions ? today : "",
  });
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pageNum, setPageNum] = useState(1);
  const [searchQuery, setSearchQuery] = useState([
    {
      field: "cancellationDate",
      condition: value === cancelledSubscriptions ? "lt" : "gt",
      filterValues: [today],
    },
  ]);

  const handleTabChange = (e, value) => {
    setValue(value);
    setPageNum(1);
    setSearchData({
      name: "",
      email: "",
      planName: "",
      startDate: value === upcomingCancelSubscriptions ? today : "",
      endDate: value === cancelledSubscriptions ? today : "",
    });
    setSearchQuery([
      {
        field: "cancellationDate",
        condition: value === cancelledSubscriptions ? "lt" : "gt",
        filterValues: [today],
      },
    ]);
  };

  useEffect(() => {
    getPlanWiseUsers(dispatch);
  }, [dispatch]);

  useEffect(() => {
    setIsLoading(true);
    let sortParam = {
      sortBy: "cancellationDate",
      sortType: value === cancelledSubscriptions ? "desc" : "asc",
    };
    cancellationSubListing(
      dispatch,
      JSON.stringify(searchQuery),
      pageNum,
      JSON.stringify(sortParam)
    );
  }, [value, pageNum]);

  useEffect(() => {
    if (data) {
      if (data?.code === 200) {
        setError(false);
        setIsLoading(false);
      } else if (data.code) {
        setError(true);
        setIsLoading(false);
      } else {
        setError(false);
        setIsLoading(true);
      }
    } else {
      setError(false);
      setIsLoading(true);
    }
  }, [data]);

  const handleChange = (name, value) => {
    if (name === "startDate") {
      setSearchData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else setSearchData((prev) => ({ ...prev, [name]: value || "" }));
  };

  const clear = () => {
    setSearchData({
      name: "",
      email: "",
      plan: "",
      startDate: value === cancelledSubscriptions ? "" : today,
      endDate: value === cancelledSubscriptions ? today : "",
    });
    setIsLoading(true);
    setPageNum(1);
    const newQuery = [
      {
        field: "cancellationDate",
        condition: value === cancelledSubscriptions ? "lt" : "gt",
        filterValues: [today],
      },
    ];
    setSearchQuery(newQuery);
    let sortParam = {
      sortBy: "cancellationDate",
      sortType: value === cancelledSubscriptions ? "desc" : "asc",
    };
    cancellationSubListing(
      dispatch,
      JSON.stringify(newQuery),
      pageNum,
      JSON.stringify(sortParam)
    );
  };

  const handleSearch = () => {
    let query = [];

    for (const [key, value] of Object.entries(searchData)) {
      if (value) {
        if (key === "startDate" || key === "endDate") {
          let startDate = searchData.startDate;
          let endDate = searchData.endDate;

          if (startDate || endDate) {
            const filterValues = [];
            if (startDate) filterValues.push(startDate);
            if (endDate) filterValues.push(endDate);
            query = query.filter((q) => q.field !== "cancellationDate"); // Remove existing date filter if any
            query.push({
              field: "cancellationDate",
              condition: endDate && startDate ? "btw" : endDate ? "lt" : "gt",
              filterValues: filterValues,
            });
          }
        } else {
          query.push({
            field: key,
            condition: "like",
            filterValues: [value],
          });
        }
      }
    }
    if (query.length === 0) {
      query.push({
        field: "cancellationDate",
        condition: "gt",
        filterValues: [today],
      });
      setSearchData((prev) => ({
        ...prev,
        startDate: today,
      }));
    }
    setSearchQuery(query);
    setPageNum(1);
    setIsLoading(true);
    let sortParam = {
      sortBy: "cancellationDate",
      sortType: value === cancelledSubscriptions ? "desc" : "asc",
    };
    cancellationSubListing(
      dispatch,
      JSON.stringify(query),
      1,
      JSON.stringify(sortParam)
    );
  };

  const planOptions = planList?.data
    ?.filter((item) => item.name !== "Free Plan")
    .map((item) => ({
      value: item.name,
      label: item.name,
    }));

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      setIsLoading(true);
      handleSearch();
    }
  };

  return (
    <>
      <TimelineHeader name="Cancelled Subscription" />
      <Container onKeyDownCapture={onKeyDown} className="mt--6" fluid>
        <Card className="mb-1">
          <Row lg="12" md="12" sm="12">
            <Col lg="12" md="12" sm="12">
              <Tabs
                variant="fullWidth"
                value={value}
                onChange={handleTabChange}
                className="border-bottom bg-white p-2 pt-3"
                style={{ borderRadius: "0.4rem" }}
              >
                <Tab
                  label="Cancelled Subscriptions"
                  value="CANCELLED_SUBSCRIPTIONS"
                />
                <Tab
                  label="Upcoming Subscription Cancellation"
                  value="UPCOMING_CANCELLED_SUBSCRIPTIONS"
                />
              </Tabs>
            </Col>
          </Row>
        </Card>
        {(value === cancelledSubscriptions ||
          value === upcomingCancelSubscriptions) && (
          <Card>
            <CardBody>
              <div style={styles.filterCon}>
                <Input
                  placeholder="Search Name"
                  type="text"
                  style={styles.input}
                  name="name"
                  value={searchData.name}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
                <Input
                  placeholder="Search Email"
                  type="text"
                  style={styles.input}
                  name="email"
                  value={searchData.email}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                />
                <Select
                  options={planOptions}
                  value={
                    planOptions?.find(
                      (option) => option.value === searchData.planName
                    ) || null
                  }
                  onChange={(e) => {
                    handleChange("planName", e?.value);
                  }}
                  placeholder="Select Plan"
                  isClearable
                  styles={customStyles}
                  // onKeyDown={props.handleKeyPress}
                />
                {value === upcomingCancelSubscriptions && (
                  <div className="d-flex">
                    <Label className="mt-2 ml-2 text-muted">Start Date</Label>
                    <Input
                      style={styles.cal}
                      onChange={(e) =>
                        handleChange(e.target.name, e.target.value)
                      }
                      value={searchData.startDate}
                      type="date"
                      id="startDate"
                      name="startDate"
                      min={today}
                      //   onKeyPress={props.handleKeyPress}
                    />
                  </div>
                )}
                {value === upcomingCancelSubscriptions && (
                  <div className="d-flex">
                    <Label className="mt-2 ml-2 text-muted">End Date</Label>
                    <Input
                      style={styles.cal}
                      onChange={(e) =>
                        handleChange(e.target.name, e.target.value)
                      }
                      value={searchData.endDate}
                      type="date"
                      id="endDate"
                      name="endDate"
                      min={today}
                      // max={new Date().toISOString().split("T")[0]}
                      //   onKeyPress={props.handleKeyPress}
                    />
                  </div>
                )}
                <Button
                  onClick={() => handleSearch()}
                  style={styles.btn}
                  size="md"
                  outline
                  color="info"
                >
                  Search
                </Button>
                <Button
                  onClick={() => clear()}
                  style={styles.btn}
                  size="md"
                  outline
                  color="info"
                >
                  Clear
                </Button>
              </div>
              <Row lg="12" md="12" sm="12">
                {isLoading ? (
                  <div style={styles.loaderContainer}>
                    <i
                      className="fa fa-spinner fa-spin fa-2xl"
                      style={styles.loaderColor}
                    />
                  </div>
                ) : error ? (
                  <div style={styles.loaderContainer}>
                    <p style={styles.loaderText}>Something went wrong</p>
                  </div>
                ) : (
                  <>
                    {data?.data?.totalRecords ? (
                      <ToolkitProvider
                        data={
                          data?.data?.cancelledSubscriptions
                            ? data?.data?.cancelledSubscriptions
                            : []
                        }
                        key={"ID"}
                        keyField="ID"
                        columns={[
                          {
                            dataField: "tenantID",
                            text: "ID",
                            sort: true,
                          },
                          {
                            dataField: "firstName",
                            text: "Name",
                            sort: true,
                            formatter: (cell, row) => {
                              return `${cell} ${row.lastName}`;
                            },
                          },
                          {
                            dataField: "email",
                            text: "Email",
                            sort: true,
                          },
                          {
                            dataField: "planName",
                            text: "Plan",
                            sort: true,
                          },
                          {
                            dataField: "usdRate",
                            text: "Plan Cost",
                            sort: false,
                            formatter: (cell, row) => (
                              <span>
                                {row.currency === "INR"
                                  ? CURRENCY_SYMBOL.INR + row.inrRate
                                  : CURRENCY_SYMBOL.USD + row.usdRate}
                              </span>
                            ),
                          },
                          {
                            dataField: "cancellationInitiatedAt",
                            text: "Cancellation Initiated At",
                            sort: true,
                            hidden: value === cancelledSubscriptions,
                          },
                          {
                            dataField: "cancellationDate",
                            text:
                              value === cancelledSubscriptions
                                ? "Cancelled On"
                                : "Cancellation Date",
                            sort: true,
                          },
                          {
                            dataField: "subscriptionID",
                            text: "Subscription ID",
                            sort: false,
                          },
                          {
                            dataField: "remark",
                            text: "Remark",
                            sort: true,
                            formatter: (cell, row) => {
                              if (cell.length >= 30) {
                                let temp = cell.substring(0, 30) + "...";
                                return (
                                  <>
                                    <span id={`tooltipEdit${row.ID}`}>
                                      {temp}
                                    </span>
                                    <UncontrolledTooltip
                                      target={`tooltipEdit${row.ID}`}
                                    >
                                      {cell}
                                    </UncontrolledTooltip>
                                  </>
                                );
                              } else return cell;
                            },
                          },
                        ]}
                        search
                      >
                        {(props) => (
                          <div className="py-4 table-responsive">
                            <BootstrapTable
                              {...props.baseProps}
                              key={"ID"}
                              keyField="ID"
                              bootstrap4={true}
                              bordered={false}
                              // selectRow={{
                              //   onSelect: (e, isSelect, rowIndex) =>
                              //     console.log(e, isSelect, rowIndex),
                              // }}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    ) : (
                      <div style={styles.loaderContainer}>
                        <p style={styles.loaderText}>No Record Found</p>
                      </div>
                    )}
                  </>
                )}
              </Row>
              <CustomPagination
                totalPages={Math.ceil(
                  data?.data?.totalRecords / data?.data?.noOfRecordsPerPage
                )}
                setPageNum={setPageNum}
                activePage={pageNum}
              />
            </CardBody>
          </Card>
        )}
      </Container>
    </>
  );
}

export default CancelledSubscription;

const styles = {
  btn: {
    margin: 0,
    height: "2.375rem",
    display: "flex",
    alignItems: "center",
  },
  cal: {
    width: "8.75rem",
    marginLeft: "0.3125rem",
    height: "2.375rem",
    color: GRAY,
  },
  filterCon: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.625rem",
  },
  input: {
    width: "10rem",
    height: "2.375rem",
  },
  loaderColor: { color: cyanBlue },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "10vh",
    width: "100%",
  },
  loaderText: {
    margin: "auto",
    fontWeight: "normal",
  },
  cardStyle: { marginLeft: "0.4rem", marginRight: "0.4rem" },
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "10rem",
    fontSize: "0.875rem", // Font size for the input
    borderColor: state.isFocused ? LIGHT_GRAY : LIGHT_GRAY, // Border color when focused and unfocused
    boxShadow: state.isFocused ? `0 0 0 1px ${LIGHT_GRAY}` : "none", // Remove default shadow on focus
    "&:hover": {
      borderColor: LIGHT_GRAY, // Border color on hover
    },
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.875rem", // Font size for dropdown items
  }),
  singleValue: (provided) => ({
    ...provided,
    color: GRAY, // Text color for the input
  }),
  placeholder: (provided) => ({
    ...provided,
    color: GRAY,
  }),
};
